module.exports = __webpack_public_path__ + "static/media/banner6.c74d86df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner6.png
// module id = 174
// module chunks = 10